module.exports = __webpack_public_path__ + "static/img/materialsInfo9.4a0f5b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo9.png
// module id = 0gJA
// module chunks = 2